import React from 'react';
import { Icon, Input, Select } from 'antd';

import * as ui from '@digital/ui';
import { dateFormat } from '@app/helpers/dateTimeFormats';

import moment from 'moment';
import { Button, Col, Form, FormResetButton, Row } from '@digital/ui';
import { SelectInfinity } from '@app/components';

interface IProps {
    nameInputForm: string;
    placeholder: string;
    setSelectedKeys: ((selectedKeys: string[]) => void) | undefined;
    selectedKeys: string[] | undefined;
    confirm: (() => void) | undefined;
    clearFilters: ((selectedKeys: string[]) => void) | undefined;
}

interface IPropsDateRange {
    nameInputForm: string;
    setSelectedKeys: ((selectedKeys: string[]) => void) | undefined;
    selectedKeys: string[] | undefined;
    confirm: (() => void) | undefined;
    clearFilters: ((selectedKeys: string[]) => void) | undefined;
}


export const FormFilterDropDown = ({ nameInputForm, placeholder, setSelectedKeys, selectedKeys, confirm, clearFilters }: IProps) => {
    return (
        <ui.Form
            id="mrn-form-formFilterDropDown"
        >
            <ui.Row>
                <ui.FormInput
                    id={`mrn-input-${nameInputForm}`}
                    placeholder={placeholder}
                    name={nameInputForm}
                    style={{ marginTop: '15px' }}
                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                    onPressEnter={() => {
                        if (typeof confirm === 'function') confirm();
                    }}
                />
            </ui.Row>
            <ui.Row>
                <ui.Col span={6}>
                    <ui.Button
                        id={`mrn-button-${nameInputForm}-search`}
                        type="primary"
                        style={{ marginLeft: '5px' }}
                        onClick={() => {
                            if (typeof confirm === 'function') confirm();
                        }}
                        icon="commons-search"
                        size="small">
                        Pesquisar
                    </ui.Button>
                </ui.Col>
                <ui.Col span={6}>
                    <ui.FormResetButton
                        id={`mrn-button-${nameInputForm}-reset`}
                        size="small"
                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                        beforeReset={() => {
                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                        }}>
                        Limpar
                    </ui.FormResetButton>
                </ui.Col>
            </ui.Row>
        </ui.Form>
    );
};

export const mountFormFilterDropDown = (nameColum: string, placeholder: string): ui.ColumnProps<any> => {
    return {
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => FormFilterDropDown({
            nameInputForm: nameColum,
            placeholder,
            selectedKeys,
            setSelectedKeys,
            confirm,
            clearFilters,
        }),
        filterIcon: (filtered: any) => {
            const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
            return <Icon id="mrn-icon-search" type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
            try {
                if (record != undefined
                    && record.hasOwnProperty(nameColum)
                    && record[nameColum] != null) {
                    return record[nameColum]
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            } catch (e) {
            }
            return false;
        }
    };
};

export const FormFilterDropDownDateRange = ({ nameInputForm, setSelectedKeys, selectedKeys, confirm, clearFilters }: IPropsDateRange) => {
    if (selectedKeys && selectedKeys.length === 1) {
        // console.log(JSON.parse(selectedKeys[0]));
    }

    return (
        <ui.Form
            id="mrn-form-formFilterDropDown"
        >
            <ui.Row>
                <ui.FormRangePicker
                    id={`mrn-input-${nameInputForm}`}
                    name={nameInputForm}
                    style={{ marginTop: '15px' }}
                    onChange={dates => (setSelectedKeys ? setSelectedKeys([JSON.stringify(dates)]) : () => { })}
                    value={selectedKeys && selectedKeys.length === 1 && [moment(JSON.parse(selectedKeys[0])[0]), moment(JSON.parse(selectedKeys[0])[1])]}
                    startName="dataInicio"
                    endName="dataFinal"
                    format={dateFormat}
                />
            </ui.Row>
            <ui.Row>
                <ui.Col span={6}>
                    <ui.Button
                        id={`mrn-button-${nameInputForm}-search`}
                        type="primary"
                        style={{ marginLeft: '5px' }}
                        onClick={() => {
                            if (typeof confirm === 'function') confirm();
                        }}
                        icon="commons-search"
                        size="small">
                        Pesquisar
                    </ui.Button>
                </ui.Col>
                <ui.Col span={6}>
                    <ui.FormResetButton
                        id={`mrn-button-${nameInputForm}-reset`}
                        size="small"
                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                        beforeReset={() => {
                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                        }}>
                        Limpar
                    </ui.FormResetButton>
                </ui.Col>
            </ui.Row>
        </ui.Form>
    );
};

export const mountFormFilterDropDownDateRange = (nameColum: string): ui.ColumnProps<any> => {
    return {
        filterMultiple: true,
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => FormFilterDropDownDateRange({
            nameInputForm: nameColum,
            selectedKeys,
            setSelectedKeys,
            confirm,
            clearFilters,
        }),
        filterIcon: (filtered: any) => {
            const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
            return <Icon id="mrn-icon-search" type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
            const inicio = moment(JSON.parse(value)[0]).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
            const fim = moment(JSON.parse(value)[1]).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
            try {
                if (record != undefined
                    && record.hasOwnProperty(nameColum)
                    && record[nameColum] != null) {
                    const valorRecord = moment(record[nameColum]).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
                    return valorRecord.isBetween(inicio, fim, null, '[]');
                }
            } catch (e) {
            }
            return false;
        }
    };
};

export const mountFormFilterDropDownServerWithSelectInfinity = <T extends Record<string, any>>(
  nameColumn: string,
  placeholder: string,
  data: T[],
  valueKey: string,
  handleSelect: (record: any, value: any) => void,
  paginationSize: number = 10
): ui.ColumnProps<any> => {
  return {
    render: (text, record) => {
      const hasValueOnRow = record && valueKey in record && record[valueKey] != null && record[valueKey] !== '';
      if (!hasValueOnRow) {
        return <span>{text ? text : ''}</span>;
      } return (
      <SelectInfinity
        paginationOptions={data || []}
        paginationSize={paginationSize}
        value={record[valueKey]}
        onChange={(value) => handleSelect(record, value)}
      />
    )
  },
    ...mountFormFilterDropDownServer(nameColumn, placeholder)
  };
};


export const mountFormFilterDropDownServer = (
  nameColum: string,
  placeholder: string
): ui.ColumnProps<any> => {
  return {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) =>
      FormFilterDropDown({
        nameInputForm: nameColum,
        placeholder,
        selectedKeys,
        setSelectedKeys,
        confirm,
        clearFilters,
      }),
    filterIcon: (filtered: any) => {
      const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
      return (
        <Icon
          id="mrn-icon-search"
          type="search"
          className={classes}
          style={{ minWidth: 'auto', border: 'none' }}
        />
      );
    },
    // remove onFilter para não filtrar no client
  };
};


interface FilterOption {
  text: string;
  value: string;
}

export const mountFormSelectFilterDropDownServer = (
  nameColumn: string,
  placeholder: string,
  filters: FilterOption[]
): ui.ColumnProps<any> => {
  return {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <Form>
        <Row>
          <Select
            allowClear
            showSearch
            placeholder={placeholder}
            value={(selectedKeys && selectedKeys.length > 0) ? selectedKeys[0] : undefined}
            onChange={(value) => {
              if (setSelectedKeys) setSelectedKeys(value ? [value] : []);
              if (confirm) confirm(); // ✅ dispara automaticamente
            }}
            style={{ width: '100%', minWidth: 100, marginTop: '15px' }}
          >
            {filters.map((filter) => (
              <Option key={filter.value} value={filter.value}>
                {filter.text}
              </Option>
            ))}
          </Select>
        </Row>

        <Row style={{ marginTop: 8 }}>
          <Col span={24}>
            <FormResetButton
              size="small"
              style={{ float: 'right', marginTop: 5 }}
              beforeReset={() => {
                if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
              }}
            >
              Limpar
            </FormResetButton>
          </Col>
        </Row>
      </Form>
    ),
    filterIcon: (filtered: boolean) => {
      const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
      return (
        <Icon
          id="mrn-icon-search"
          type="search"
          className={classes}
          style={{ minWidth: 'auto', border: 'none' }}
        />
      );
    },
    // sem onFilter para deixar a lógica no server
  };
};